import React, { useState, useEffect } from 'react';
import { 
  TrendingUp, Target, BarChart3, Crosshair, 
  ChevronDown, CheckCircle2, Rocket, 
  MessageCircle, ArrowRight, ShieldCheck, 
  Code, LineChart, BrainCircuit
} from 'lucide-react';

import { useNavigate, Link } from "react-router-dom";
import InscriptionModal from "../modals/InscriptionModal";
import PromoModal from "../modals/PromoModal";
import WhatsAppButton from "../header/WhatsAppButton";
import { trackMetaEvent } from "../utils/MetaPixel";

const TraffickerServices = () => {
  // const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 150); // Se activa después de 150px de scroll
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  // Función para hacer scroll suave a las secciones
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      // Calculamos la posición restando un poco de margen superior (por el menú fijo si lo hubiera)
      const yOffset = -50; 
      const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const phoneNumber = "573014953565"; // Tu número real
  
  const packages = [
    {
      id: 1,
      name: "Mentoría: Yo te enseño",
      price: "$399.000",
      oldPrice: "$640.000",
      period: "Pago Único",
      desc: "Curso online y mentoría. Ideal si tienes tiempo y quieres aprender a armar tus campañas con la estrategia correcta.",
      features: [
        "Auditoría de tu Business Manager",
        "Estructuración de campaña ganadora",
        "Creación de ángulos y segmentación",
        "Soporte vía WhatsApp (15 días)",
        "Sesión en vivo de 2 horas"
      ],
      cta: "Comprar Este Servicio"
    },
    {
      id: 2,
      name: "Gestión de Campañas",
      price: "$699.000",
      oldPrice: "$1.200.000",
      period: "Mensual",
      desc: "Tú me pasas el contenido, yo construyo la máquina de ventas, armo la estrategia y optimizo a diario.",
      features: [
        "Estrategia publicitaria omnicanal",
        "Creación y gestión de campañas en Meta",
        "Escalamiento basado en análisis de datos",
        "Reportes analíticos quincenales",
        "GRATIS: Curso de Cierre de Ventas por WhatsApp"
      ],
      cta: "Comprar Este Servicio",
      highlight: true
    },
    {
      id: 3,
      name: "Servicio Full Stack",
      price: "$1.199.000",
      oldPrice: "$1.950.000",
      period: "Mensual",
      desc: "Me encargo de TODO. Grabo en tu negocio, edito, armo estrategia y escalo las campañas.",
      features: [
        "Todo lo incluido en el plan Gestión",
        "Grabación de contenido en tu negocio",
        "Edición profesional para pauta",
        "Guiones persuasivos para tus videos",
        "GRATIS: Curso de Cierre de Ventas por WhatsApp"
      ],
      cta: "Comprar Este Servicio"
    }
  ];

  const faqs = [
    {
      q: "¿Cuánto debo invertir en publicidad aparte de tu servicio?",
      a: "Recomiendo una inversión mínima de $20.000 COP diarios por producto o servicio directamente a Meta (Facebook/Instagram) para que los algoritmos tengan data suficiente y podamos ver resultados rápidos y escalables."
    },
    {
      q: "¿En cuánto tiempo veré resultados?",
      a: "La fase de testeo y aprendizaje suele tomar entre 7 y 14 días. Durante este tiempo identificamos qué anuncios y públicos responden mejor. A partir de la segunda semana comenzamos a estabilizar y escalar el retorno."
    },
    {
      q: "Si elijo el plan Gestión, ¿quién hace los diseños?",
      a: "Tú o tu equipo deben proveerme el material (fotos/videos). Yo te indicaré exactamente qué grabar mediante guiones. Si quieres que yo grabe y edite, debes elegir el plan Full Stack."
    }
  ];

  return (
    <div id="import-course-lp" className="min-h-screen bg-[#050b1a] text-slate-200 font-sans selection:bg-cyan-500 selection:text-white pb-10 relative">
      
      {/* Estilos CSS Inline para animaciones complejas */}
      <style>{`
        .bg-grid {
          background-size: 40px 40px;
          background-image: 
            linear-gradient(to right, rgba(255, 255, 255, 0.05) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
          mask-image: linear-gradient(to bottom, black 40%, transparent 100%);
          -webkit-mask-image: linear-gradient(to bottom, black 40%, transparent 100%);
        }
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0px); }
        }
        .animate-float { animation: float 5s ease-in-out infinite; }
        
        /* Asegurando que el texto resalte independientemente de la configuración global */
        .highlight-text-safe {
            color: #22d3ee; /* cyan-400 */
            text-shadow: 0 0 15px rgba(34, 211, 238, 0.6), 0 0 30px rgba(34, 211, 238, 0.4);
            font-weight: 900;
        }
      `}</style>

      {/* Hook Banner Superiror - Aparece con Scroll y está en el TOP absoluto */}
      <div 
        className={`bg-red-600 text-white text-center font-bold py-2 text-sm sm:text-base fixed top-0 left-0 right-0 z-[100] tracking-wide transition-all duration-500 transform
          ${isScrolled ? 'translate-y-0 opacity-100 shadow-lg' : '-translate-y-full opacity-0'}
        `}
      >
        ⚠️ ¿Tu negocio tiene visibilidad pero no ventas? Esto te va a cambiar el juego
      </div>

      {/* HERO SECTION */}
      <section className="relative pt-36 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
        <div className="absolute inset-0 bg-grid z-0"></div>
        
        {/* Glows de fondo */}
        <div className="absolute top-1/4 -left-32 w-96 h-96 bg-blue-600/30 rounded-full blur-[120px] pointer-events-none"></div>
        <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-cyan-400/20 rounded-full blur-[120px] pointer-events-none"></div>

        <div className="max-w-5xl mx-auto px-6 relative z-10 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-500/10 border border-cyan-500/30 text-cyan-300 text-xs md:text-sm font-medium mb-8">
            <span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse"></span>
            Para negocios que quieren vender más, no solo aparecer más
          </div>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight leading-[1.1] mb-6 drop-shadow-lg">
            Tu negocio no necesita más seguidores. Necesita un sistema que  <br className="hidden md:block"/>
            <span className="highlight-text-safe">
              convierta extraños en clientes todos los días.
            </span>
          </h1>
          
          <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto font-light leading-relaxed">
            Soy <strong>Ingeniero en Informática y Estratega Digital</strong>. Aplico ciencia de datos, embudos y persuasión para crear campañas que escalan la facturación de tu negocio.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            {/* Botón Principal Llamativo con Scroll Suave */}
            <button 
                onClick={(e) => scrollToSection(e, 'planes')}
                className="w-full sm:w-auto px-8 py-4 bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-black rounded-full transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(6,182,212,0.6)] flex items-center justify-center gap-2 border-2 border-cyan-300"
            >
              <Rocket className="w-5 h-5" /> Quiero vender más → Ver cómo
            </button>

            <button 
                onClick={(e) => scrollToSection(e, 'autoridad')}
                className="w-full sm:w-auto px-8 py-4 bg-white/5 hover:bg-white/10 border border-white/20 text-white font-bold rounded-full transition-all flex items-center justify-center gap-2"
            >
              <BarChart3 className="w-5 h-5 text-slate-400" /> ¿Cómo lo hago? Descúbrelo
            </button>
          </div>

          <div className="mt-12 flex flex-wrap justify-center gap-6 opacity-80 text-sm font-semibold tracking-widest uppercase">
            <span className="flex items-center gap-2"> 🚀 +18 negocios escalados</span>
            <span className="flex items-center gap-2"> 📊 Campañas desde $80K pesos</span>
            <span className="flex items-center gap-2"> 💬 Resultados en pocos días</span>
          </div>
        </div>
      </section>

      {/* PAIN POINTS (Dolores) */}
      <section className="py-24 bg-[#0a1128] relative border-y border-white/5">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 drop-shadow-md">¿Te suena familiar alguna de estas pesadillas?</h2>
            <p className="text-slate-400">Si respondiste "sí" a alguna, tu estrategia publicitaria actual está rota.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-[#0f172a] p-8 rounded-2xl border border-red-500/20 hover:border-red-500/40 transition-colors shadow-lg">
              <div className="w-12 h-12 bg-red-500/10 rounded-xl flex items-center justify-center mb-6">
                <TrendingUp className="w-6 h-6 text-red-400 transform rotate-180" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Muchos "Likes", Cero Ventas</h3>
              <p className="text-slate-400 text-sm leading-relaxed">Tus anuncios generan interacciones y comentarios vacíos de personas que preguntan "precio" pero nunca compran.</p>
            </div>

            <div className="bg-[#0f172a] p-8 rounded-2xl border border-red-500/20 hover:border-red-500/40 transition-colors shadow-lg">
              <div className="w-12 h-12 bg-red-500/10 rounded-xl flex items-center justify-center mb-6">
                <Crosshair className="w-6 h-6 text-red-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">No hago publicidad digital</h3>
              <p className="text-slate-400 text-sm leading-relaxed">Nunca invierto en nuevos clientes y siempre son los mismos. Nunca escalo mi negocio</p>
            </div>

            <div className="bg-[#0f172a] p-8 rounded-2xl border border-red-500/20 hover:border-red-500/40 transition-colors shadow-lg">
              <div className="w-12 h-12 bg-red-500/10 rounded-xl flex items-center justify-center mb-6">
                <BrainCircuit className="w-6 h-6 text-red-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Agencias "Vende-Humo"</h3>
              <p className="text-slate-400 text-sm leading-relaxed">Estás cansado de pagar a agencias por reportes llenos de alcance, pero que no se reflejan en tu facturación.</p>
            </div>
          </div>
        </div>
      </section>

      {/* AUTHORITY / ABOUT */}
      <section id="autoridad" className="py-24 relative overflow-hidden bg-[#050b1a]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-16 items-center">
            
            <div className="lg:w-1/2 relative">
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-3xl rotate-3 opacity-20 blur-lg"></div>
              <div className="bg-[#0f172a] rounded-3xl p-8 border border-slate-700 relative z-10 animate-float shadow-2xl">
                <div className="flex items-center gap-4 mb-8 border-b border-slate-700 pb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-cyan-400 to-blue-600 rounded-full flex items-center justify-center font-bold text-2xl text-white shadow-lg">
                    IT
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white">Ingeniería + Marketing</h3>
                    <p className="text-cyan-400 text-sm font-medium">La fórmula exacta del ROI</p>
                  </div>
                </div>
                <div className="space-y-4 text-slate-300 font-medium">
                  <p className="flex gap-3"><CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0"/> Tracking avanzado y lectura de estadísticas.</p>
                  <p className="flex gap-3"><CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0"/> Decisiones basadas en Data, no en emociones.</p>
                  <p className="flex gap-3"><CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0"/> Optimización de embudos desde el clic al WhatsApp.</p>
                  <p className="flex gap-3"><CheckCircle2 className="w-5 h-5 text-cyan-400 shrink-0"/> Arquitectura de campañas orientadas a Costo por Adquisición.</p>
                </div>
              </div>
            </div>

            <div className="lg:w-1/2">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">Por qué un Ingeniero hace la diferencia en tus Anuncios</h2>
              <p className="text-slate-300 text-lg mb-6 leading-relaxed">
                El marketing moderno es 80% matemáticas y 20% creatividad. Meta es un algoritmo complejo impulsado por inteligencia artificial.
              </p>
              <p className="text-slate-300 text-lg mb-8 leading-relaxed">
                Mi formación me permite analizar la data con precisión matemática. <strong>No adivino, mido.</strong> Identifico cuellos de botella en tu embudo, estructuro el píxel para rastrear cada centavo y escalo presupuestos cuando los números dictan que es rentable.
              </p>
              
              <div className="bg-[#0f172a] border-l-4 border-cyan-500 p-6 rounded-r-xl shadow-lg">
                <p className="text-cyan-50 italic text-lg font-medium">
                  "Un publicista crea el anuncio. Un ingeniero construye el sistema que hace que ese anuncio imprima dinero predeciblemente."
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="planes" className="py-24 bg-[#0a1128] border-y border-white/5">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 drop-shadow-md">Planes de Trabajo</h2>
            <p className="text-slate-300 text-lg max-w-2xl mx-auto">Elige el nivel de acompañamiento que mejor se adapte al momento actual de tu facturación.</p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 items-stretch">
            
            {packages.map((pkg) => (
              <div 
                key={pkg.id} 
                className={`relative rounded-3xl p-8 flex flex-col transition-all duration-300 ${
                  pkg.highlight 
                    ? 'bg-[#0f172a] border-2 border-cyan-500 transform lg:-translate-y-4 shadow-[0_0_30px_rgba(6,182,212,0.2)]' 
                    : 'bg-[#0f172a] border border-slate-700 hover:border-slate-500 shadow-xl'
                }`}
              >
                {pkg.highlight && (
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-cyan-400 to-blue-500 text-white font-bold text-xs px-6 py-1.5 rounded-full uppercase tracking-widest shadow-lg whitespace-nowrap">
                    Recomendado
                  </div>
                )}
                
                <h3 className="text-2xl font-bold text-white mb-2">{pkg.name}</h3>
                <p className="text-slate-400 text-sm mb-6 min-h-[60px] leading-relaxed">{pkg.desc}</p>
                
                <div className="mb-6 pb-6 border-b border-slate-700/50">
                  <span className="block text-slate-500 line-through text-sm mb-1">{pkg.oldPrice} COP</span>
                  <span className={`text-4xl font-black ${pkg.highlight ? 'text-cyan-400 drop-shadow-md' : 'text-white'}`}>{pkg.price}</span>
                  <span className="text-slate-400 text-sm ml-2">COP / {pkg.period}</span>
                </div>

                <ul className="space-y-4 mb-8 flex-1">
                  {pkg.features.map((feat, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-sm text-slate-300 font-medium">
                      <CheckCircle2 className={`w-5 h-5 shrink-0 mt-0.5 ${pkg.highlight ? 'text-cyan-400' : 'text-blue-500'}`} />
                      <span className={feat.includes("GRATIS") ? "text-cyan-300 font-bold bg-cyan-900/30 px-2 py-0.5 rounded" : ""}>{feat}</span>
                    </li>
                  ))}
                </ul>

                <div className="space-y-3 mt-auto">
                  <a 
                    href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(`Hola, quiero adquirir el plan: ${pkg.name} por ${pkg.price}`)}`}
                    target="_blank"
                    rel="noreferrer"
                    className={`w-full py-4 rounded-xl font-bold text-center flex justify-center items-center gap-2 transition-all ${
                      pkg.highlight 
                        ? 'bg-cyan-500 hover:bg-cyan-400 text-slate-900 shadow-[0_0_20px_rgba(6,182,212,0.4)]' 
                        : 'bg-white hover:bg-gray-200 text-slate-900'
                    }`}
                  >
                     {pkg.cta} <ArrowRight className="w-5 h-5" />
                  </a>
                  
                  <a 
                    href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(`Hola, tengo dudas sobre el plan ${pkg.name}.`)}`}
                    target="_blank"
                    rel="noreferrer"
                    className="w-full py-3 rounded-xl font-bold text-center flex justify-center items-center gap-2 transition-all bg-[#1e293b] border border-slate-600 text-slate-300 hover:bg-slate-700"
                  >
                    <MessageCircle className="w-4 h-4 text-green-400" /> Aclarar dudas
                  </a>
                </div>
              </div>
            ))}

          </div>

          <div className="mt-10 text-center text-sm text-slate-400 max-w-2xl mx-auto bg-[#0f172a] p-4 rounded-lg border border-slate-800 shadow-inner">
            <p>Nota: El presupuesto destinado a la plataforma de Meta Ads no está incluido en estos honorarios y es abonado directamente por el cliente a la red social.</p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 relative bg-[#050b1a]">
        <div className="max-w-3xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">Preguntas Frecuentes</h2>
            <p className="text-slate-400">Resolvemos tus dudas antes de empezar a escalar tu negocio.</p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-[#0f172a] border border-slate-700 rounded-2xl overflow-hidden transition-all duration-300 shadow-md hover:border-slate-500"
              >
                <button 
                  onClick={() => toggleFaq(index)}
                  className="w-full px-6 py-5 flex justify-between items-center text-left focus:outline-none"
                >
                  <span className="font-semibold text-black text-lg">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-cyan-400 transition-transform duration-300 shrink-0 ${openFaq === index ? 'rotate-180' : ''}`} />
                </button>
                <div 
                  className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openFaq === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`}
                >
                  <p className="text-slate-300 text-base leading-relaxed border-t border-slate-700 pt-4">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER CTA */}
      <footer className="bg-[#020617] border-t border-slate-800 py-16 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/10 to-transparent pointer-events-none"></div>
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 drop-shadow-md">
            ¿Aún no te decides?
          </h2>
          <p className="text-slate-300 mb-10 text-lg">Escríbeme y hablemos sobre tu negocio para ver si hacemos un buen equipo.</p>
          
          <a href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent('Hola, leí tu página de servicios y me gustaría hacerte unas preguntas.')}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-[#25D366] hover:bg-[#1ebd57] text-white font-bold rounded-full transition-all shadow-[0_0_30px_rgba(37,211,102,0.4)] transform hover:scale-105 text-lg">
            <MessageCircle className="w-6 h-6" /> Escríbeme al WhatsApp
          </a>

          <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
            <div className="flex items-center gap-2 font-medium">
              <Code className="w-4 h-4 text-cyan-400" />
              <span>Ingeniería & Estrategia Digital © {new Date().getFullYear()}</span>
            </div>
            <div className="flex items-center gap-1 font-medium">
              <ShieldCheck className="w-4 h-4" /> 100% Data Driven
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default TraffickerServices;